import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import { mediumWeight } from '../../../styling/mixins/typography';
import { DESKTOP_START_QUERY } from '../../../styling/mixins/responsive';
import colors from '../../../styling/colors';

const HeaderContainer = styled.div`
  color: #000;
  padding: 1.25rem 1.5rem;
  ${mediumWeight};
  text-transform: capitalize;

  @media (min-width: 30rem) {
    padding: 1.25rem 2rem;
  }

  @media (${DESKTOP_START_QUERY}) {
    background-color: transparent;
    color: ${colors('lapel')};
    font-size: 0.625rem;
    align-items: center;
    padding: 0.5rem 0;
    text-transform: uppercase;
    letter-spacing: 0.125rem;
    display: flex;
    justify-content: space-between;
    cursor: pointer;

    & > div {
      pointer-events: none;
    }
  }
`;

const ToggleIcon = styled.div`
  color: ${colors('black')};
  font-size: 1.5rem;
`;

export class FilterHeader extends Component {
  static propTypes = {
    children: PropTypes.string.isRequired,
    isCollapsed: PropTypes.bool,
    toggleOpenCallback: PropTypes.func,
  };

  render() {
    const { children, isCollapsed, toggleOpenCallback } = this.props;

    return (
      <HeaderContainer onClick={toggleOpenCallback}>
        <div>{children}</div>
        {toggleOpenCallback ? (
          <ToggleIcon>{isCollapsed ? '+' : '-'}</ToggleIcon>
        ) : null}
      </HeaderContainer>
    );
  }
}

export default FilterHeader;
